<template>
  <div class="group-item-container">
    <div class="header">
      <feishu-group
        class="group"
        :avatar="groupInfo.avatar"
        :name="groupInfo.name"
        :groupId="groupInfo.groupId"
        :inGroup="inGroup"
        :tagInfo="tagInfo"
        :description="groupInfo.description"
      ></feishu-group>

      <div class="group-owner">
        <a-popover v-if="groupOwner">
          <template slot="content">
            <user-profile :openId="groupOwner.larkOpenId"> </user-profile>
          </template>

          <a-avatar size="large" :src="groupOwner.avatar"></a-avatar>
          <div>(群主)</div>
        </a-popover>
      </div>
      <a-icon class="icon" :type="spread ? 'up' : 'down'" @click="handleSpread" />
    </div>
    <div v-if="spread" class="detail">
      <a-popover v-for="user in commonUsers" :key="user.larkOpenId">
        <template slot="content">
          <user-profile :openId="user.larkOpenId"> </user-profile>
        </template>

        <a-avatar class="common-avatar" :src="user.avatar"></a-avatar>
      </a-popover>

      <a-popconfirm @confirm="unBindGroup">
        <template slot="title"> 解绑后飞书群将不再显示在天池系统中, <br />天池机器人自动退群并无法继续同步群内资料。 </template>
        <a-button type="link" style="color: red">取消绑定</a-button>
      </a-popconfirm>
    </div>
  </div>
</template>
<style lang="less" scoped>
.group-item-container {
  width: 100%;
}
.header {
  display: flex;
  align-items: center;
  .group {
    flex: 200px 2 1;
    max-width: 300px;
  }
  .group-owner {
    flex: 50px 1 0;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .icon {
    flex: none;
  }
}
.detail {
  margin: 10px 0 0 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.common-avatar {
  margin: 5px;
}
</style>
<script>
import feishuGroup from '@/components/feishuComponents/feishuGroup';
import userProfile from '@/components/feishuComponents/userProfile.vue';
import { mapGetters } from 'vuex';

const groupOwnerType = 2;
export default {
  components: {
    feishuGroup,
    userProfile
  },
  props: {
    groupInfo: {
      type: Object
    }
  },
  data() {
    return {
      spread: false
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    inGroup() {
      let item = this.userList.find(i => i.larkOpenId === this.userInfo.larkOpenId);
      return !!item;
    },
    userList() {
      return this.groupInfo.userList || [];
    },

    tagInfo() {
      if (this.groupInfo.isMeetingGroup) {
        return {
          text: '会议群',
          color: 'orange'
        };
      } else if (this.groupInfo.external) {
        return {
          text: '外部群',
          color: 'blue'
        };
      } else {
        return undefined;
      }
    },
    groupOwner() {
      return this.userList.find(i => i.isAdmin === groupOwnerType);
    },
    commonUsers() {
      return this.userList.filter(i => i.isAdmin !== groupOwnerType);
    }
  },
  methods: {
    handleSpread() {
      this.spread = !this.spread;
    },
    unBindGroup() {
      this.$emit('unbindGroup');
    }
  }
};
</script>
